var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.895,395.958c0,-0 -26.529,11.378 18.88,15.228c55.011,4.629 83.127,3.965 143.75,-4.497c-0,-0 15.938,7.37 38.197,13.754c-135.9,42.957 -307.569,-2.488 -200.827,-24.485",
    style: {
      fill: "#0d8ac7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.289,339.902c-0,-0 -29.755,16.244 15.687,19.711c58.765,4.471 105.173,4.837 185.477,-6.568c-0,0 11.107,8.305 28.572,12.847c-164.312,35.435 -347.326,2.794 -229.736,-25.99",
    style: {
      fill: "#0d8ac7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.285,244.813c33.486,28.433 -8.798,54.02 -8.798,54.02c0,0 85.026,-32.372 45.978,-72.91c-36.471,-37.804 -64.438,-56.587 86.968,-121.349c0,-0 -237.658,43.776 -124.148,140.239",
    style: {
      fill: "#ec2025",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.025,437.42c-0,0 19.632,11.93 -21.621,21.16c-78.444,17.526 -326.491,22.818 -395.397,0.698c-24.77,-7.948 21.681,-18.977 36.292,-21.291c15.239,-2.437 23.947,-1.983 23.947,-1.983c-27.547,-14.312 -178.052,28.103 -76.449,40.249c277.085,33.141 505.1,-14.923 433.228,-38.833",
    style: {
      fill: "#0d8ac7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.653,281.822c-0,-0 -126.173,22.102 -44.681,30.128c34.408,3.398 103,2.629 166.892,-1.319c52.216,-3.249 104.647,-10.156 104.647,-10.156c-0,0 -18.412,5.816 -31.733,12.524c-128.126,24.852 -375.641,13.291 -304.385,-12.13c60.262,-21.484 109.26,-19.047 109.26,-19.047",
    style: {
      fill: "#0d8ac7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.991,375.129c130.246,-49.916 70.025,-97.885 27.992,-91.422c-10.303,1.581 -14.896,2.952 -14.896,2.952c-0,-0 3.824,-4.419 11.129,-6.332c83.155,-21.561 147.107,63.592 -26.843,97.318c-0,0.001 2.015,-1.327 2.618,-2.516",
    style: {
      fill: "#0d8ac7",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.465,0c-0,0 72.132,53.217 -68.415,135.05c-112.704,65.644 -25.7,103.073 -0.046,145.836c-65.788,-43.776 -114.067,-82.313 -81.677,-118.179c47.54,-52.649 179.241,-78.175 150.138,-162.707",
    style: {
      fill: "#ec2025",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.451,510.39c125.02,5.903 317.002,-3.274 321.549,-46.903c0,-0 -8.74,16.539 -103.322,29.674c-106.707,14.81 -238.315,13.081 -316.374,3.59c0.002,-0.002 15.98,9.753 98.147,13.639",
    style: {
      fill: "#0d8ac7",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.b7a0bf385bbb3af7a1fd64409c3a158f.svg";
export { ForwardRef as ReactComponent };